<script setup lang="ts">
import IntakeAddressField from '@/components/Shared/ResumeUpload/IntakeAddressField.vue';
import { EMAIL_FORWARDING_LEARN_MORE_URL, useIntakeAddress } from '@/composables/useIntakeAddress';

const props = defineProps<{
  jobId: number;
}>();

const { address, displayAddress, isLoading, hasError, justCopied, fetchAddress, handleCopy } =
  useIntakeAddress(() => props.jobId);
</script>

<template>
  <div
    class="mt-4 flex flex-col items-start gap-3 border-t border-tint-60 pt-5"
    data-test-id="project-email-forwarding"
  >
    <h2 class="text-sm font-bold leading-5 text-shade-900">
      Automatically forward resumes to this job via email
    </h2>

    <IntakeAddressField
      :address="address"
      :display-address="displayAddress"
      :is-loading="isLoading"
      :has-error="hasError"
      :just-copied="justCopied"
      @copy="handleCopy"
      @retry="fetchAddress"
    />

    <a
      v-if="address && !hasError"
      :href="EMAIL_FORWARDING_LEARN_MORE_URL"
      target="_blank"
      rel="noopener noreferrer"
      class="text-xs font-bold text-highlight-500 hover:underline"
    >
      Learn more about email forwarding →
    </a>
  </div>
</template>
